import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationFlowEntity } from './outreach-automation-flow.entity';
import { OutreachAutomationStepConnectionEntity } from './outreach-automation-step-connection.entity';
import { OutreachAutomationStepExecutionEntity } from './outreach-automation-step-execution.entity';

@Entity('_outreach_automation_step')
export class OutreachAutomationStepEntity extends BaseEntity {
	@Column('enum', {
		name: '_step_type',
		enum: [
			'start',
			'template',
			'condition',
			'delay',
			'action',
			'split',
			'agent',
		],
	})
	public stepType!:
		| 'start'
		| 'template'
		| 'condition'
		| 'delay'
		| 'action'
		| 'split'
		| 'agent';

	@Column('varchar', { name: '_step_name', length: 255 })
	public stepName!: string;

	@Column('int', { name: '_step_order' })
	public stepOrder!: number;

	@Column('varchar', { name: '_branch_condition', nullable: true, length: 50 })
	public branchCondition!: string | null;

	@Column('json', { name: '_config' })
	public config!: object;

	@Column('int', { name: '_position_x', default: () => "'0'" })
	public positionX!: number;

	@Column('int', { name: '_position_y', default: () => "'0'" })
	public positionY!: number;

	@Column('tinyint', { name: '_is_active', default: () => "'1'" })
	public isActive!: number;

	@ManyToOne(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) => outreachAutomationStep.outreachAutomationSteps,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: '_fk__parent_outreach_automation_step__id',
			referencedColumnName: 'id',
		},
	])
	public fkParentOutreachAutomationStep!: OutreachAutomationStepEntity;

	@OneToMany(
		() => OutreachAutomationStepEntity,
		(outreachAutomationStep) =>
			outreachAutomationStep.fkParentOutreachAutomationStep,
		{},
	)
	public outreachAutomationSteps!: Array<OutreachAutomationStepEntity>;

	@ManyToOne(
		() => OutreachAutomationFlowEntity,
		(outreachAutomationFlow) => outreachAutomationFlow.outreachAutomationSteps,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_automation_flow__id', referencedColumnName: 'id' },
	])
	public fkOutreachAutomationFlow!: OutreachAutomationFlowEntity;

	@OneToMany(
		() => OutreachAutomationStepConnectionEntity,
		(outreachAutomationStepConnection) =>
			outreachAutomationStepConnection.fkFromStep,
		{},
	)
	public outreachAutomationStepConnections!: Array<OutreachAutomationStepConnectionEntity>;

	@OneToMany(
		() => OutreachAutomationStepConnectionEntity,
		(outreachAutomationStepConnection) =>
			outreachAutomationStepConnection.fkToStep,
		{},
	)
	public outreachAutomationStepConnections2!: Array<OutreachAutomationStepConnectionEntity>;

	@OneToMany(
		() => OutreachAutomationStepExecutionEntity,
		(outreachAutomationStepExecution) =>
			outreachAutomationStepExecution.fkOutreachAutomationStep,
		{},
	)
	public outreachAutomationStepExecutions!: Array<OutreachAutomationStepExecutionEntity>;
}
